<template>
    <div>
        <list :header="header" :body="body" :rows="invoiceList" :showNoDataMessage="false"></list>
    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex'
import List from '@/tools/list/baseList'
// mixins
import { invoicesMixin } from '@/mixins/invoices'

export default {
    data: function () {
        return {

        }
    },
    props: {
        invoiceList: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    mixins: [
        invoicesMixin
    ],
    computed: {
        ...mapGetters([
            'getInvoiceTargetTypes'
        ]),
        header: function() {
            let vm = this
            return {
                selection: {
                    active: false,
                    event: function(event) {
                        console.log('selecte all', event);
                        vm.selectAllReservations(event)
                    }
                },
                list: {
                    date: 'Date',
                    number: 'Number',
                    type: 'Type',
                    client: 'Client',
                    linked: 'Linked to',
                    amount: 'Amount'
                },
                customClassCell: {
                    amount : 'text-right',
                },
            };
        },
        body: function() {
            let vm = this;

            return {
                selection: {
                    active: false,
                    event: function(event, row) {
                        console.log('checkbox', event, row);
                    }
                },
                customRowEvent: function(row) {
                    // vm.view(reservation.id)
                    vm.setSelectedInvoice(row)
                    vm.$emit('toggleInvoiceModal')
                },
                customCells: {
                    date: function(row) {
                        let thisInvoice = vm.normalizeInvoice(row)
                        return moment(thisInvoice.date).format('DD.MM.YYYY');
                    },
                    number: function (row) {
                        let thisInvoice = vm.normalizeInvoice(row)
                        return thisInvoice.code
                    },
                    type: function (row) {
                        let invoice = vm.normalizeInvoice(row)

                        let output = '<div class="d-flex"><span>'+invoice.type.label+'</span>'
                        if(invoice.bookingInvoiceLinkedId != null || !invoice.isActive){
                            output += '<span class="lightest fs-smallest ml-2 px-3 py-1 bg-color-6 radius-stadium text-center font-weight-600" style="">Canceled</span>'
                        }
                        output += '</div>'

                        return output
                    },
                    client: function (row) {
                        let thisInvoice = vm.normalizeInvoice(row)
                        return thisInvoice.name
                    },
                    linked: function(row) {
                        let invoice = vm.normalizeInvoice(row)
                        let output = '<div class="d-flex"><div class="lightest fs-smallest px-2 py-1 bg-dark radius-stadium text-center font-weight-600" style="min-width: 120px;">'
                        output += invoice.bookingRelationsQuantity+' Booking'+( (invoice.bookingRelationsQuantity > 1)? 's':'')
                        output += '</div></div>'
                        return output
                    },
                    amount: function (row) {
                        let thisInvoice = vm.normalizeInvoice(row)
                        return vm.formatPrice(thisInvoice.value)+'€'
                    },
                },
                customClassCell: {
                    date : 'pointer',
                    number : 'pointer',
                    type : 'pointer',
                    client : 'pointer',
                    amount : 'pointer text-right',
                    // bookingQuantity: 'd-flex',
                },
                // rowEvent: this.view(event)
            }
        }
    },
    methods: {
        ...mapActions([
            'setSelectedInvoice'
        ])
    },
    components: {
        List
    }
}
</script>

<style lang="scss" scoped="">
</style>



// WEBPACK FOOTER //
// InvoiceList.vue?2ffdfa3b